
export function auth(
  extra: Record<string, string | undefined> = {},
): Record<string, string | undefined> {
  return extra;
}
